import { ratingTypes } from 'shared/constants/ratingTypes';

export const serviceUrlPrefix = {
  [ratingTypes.CREDIT_RATING]: '',
  [ratingTypes.CREDIT_REVIEW]: '/sig/api',
  [ratingTypes.ESG_IMPACT]: '/esg/api',
  [ratingTypes.SENTIMENT]: '/sentifi',
};
